<template>
  <a :href="href" class="tw-absolute tw-w-full tw-h-full tw-object-cover tw-top-0 tw-left-0 tw-absolute" @mouseenter="hoverOnLink">
    <video loop
           muted
           ref="video_player"
           v-if="hoveredOnLink"
           @mouseenter="hoverOnVideo"
           @mouseleave="hoverOffVideo"
           class="tw-absolute tw-w-full tw-h-full tw-object-cover tw-top-0 tw-left-0 tw-absolute"
           :data-poster="thumb">
      <source :src="video" type="video/mp4"/>
    </video>
  </a>

</template>

<script>

export default {
  data() {
    return {
      hoveredOnLink: false
    }
  },
  props: ['thumb', 'video', 'assetId', 'play', 'href'],
  methods: {
    hoverOnLink() {
      this.hoveredOnLink = true

      this.$nextTick(() => {
        this.$refs['video_player'].play()
      })
    },

    hoverOnVideo() {
      this.$refs['video_player'].play()
    },

    hoverOffVideo() {
      this.$refs['video_player'].pause()
    },

  },
  watch: {
    play: function (val) {
      if (val) {
        this.$refs['video_player'].play()
      } else {
        this.$refs['video_player'].pause()
      }
    }
  }
}

</script>